import { render, staticRenderFns } from "./BarGraphOptions.vue?vue&type=template&id=6b7ae52a&"
import script from "./BarGraphOptions.vue?vue&type=script&lang=js&"
export * from "./BarGraphOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports